(function () {
  var LABEL = 'اشتري الآن';

  function relabelBuyButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.shopify-payment-button__button--unbranded').forEach(function (btn) {
      var text = (btn.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text === LABEL) return;
      if (/buy it now/i.test(text) || !/اشتري/.test(text)) {
        btn.textContent = LABEL;
        btn.setAttribute('aria-label', LABEL);
      }
    });
  }

  function boot() {
    relabelBuyButtons(document);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' || m.type === 'characterData') {
          relabelBuyButtons(document);
          break;
        }
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
